import React from 'react';

const painPoints = [
  { icon: '📞', text: 'Missed calls = lost revenue' },
  { icon: '⏳', text: 'Slow replies = lost clients' },
  { icon: '📋', text: 'Manual booking & follow-ups waste hours' },
  { icon: '💻', text: 'Website just "exists" — doesn\'t convert' },
];

export default function ProblemSolution() {
  return (
    <section className="py-28 px-6 w-full" style={{ background: '#061a12' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: 'rgba(255,255,255,0.4)' }}>The Problem</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight leading-tight">
            You're Not Just Losing Leads —{' '}
            <span style={{ color: '#d4f542' }}>You're Losing Time</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12 max-w-2xl mx-auto">
          {painPoints.map((pt, i) => (
            <div
              key={i}
              className="flex items-start gap-4 p-6 rounded-2xl"
              style={{ background: '#0c2d1e', border: '1px solid rgba(255,255,255,0.07)' }}
            >
              <span className="text-xl flex-shrink-0">{pt.icon}</span>
              <span className="text-base font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>{pt.text}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div
            className="inline-block px-8 py-5 rounded-2xl"
            style={{ background: 'rgba(212,245,66,0.06)', border: '1px solid rgba(212,245,66,0.2)' }}
          >
            <p className="text-lg md:text-xl font-semibold" style={{ color: '#d4f542' }}>
              "Most businesses lose 30–50% of potential clients<br className="hidden md:block" /> due to slow response."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

